<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Icon, IconButton } from '@Shelly/shelly-design-system';
	import Map from './Mapbox/MapBox.svelte';
	import MapMarker from './Mapbox/MapMarker.svelte';

	export let lat: number;
	export let lng: number;
	export let disabled = false;

	const dispatch = createEventDispatcher();
</script>

<div class="location-preview">
	<IconButton
		icon="fas fa-expand"
		variant="secondary"
		class="flex-shrink-0"
		{disabled}
		aria-label={$format('select_map_location', { default: 'Select from map' })}
		on:click={() => {
			if (!disabled) dispatch('open');
		}}
	/>
	<div class="location-preview-map">
		<Map center={[lng, lat]} zoom={14} mapParentSize interactive={false} followCenter>
			{#key `${lat}-${lng}`}
				<MapMarker {lat} {lng} draggable={false}>
					<Icon
						icon="fa fa-times"
						class="text-danger"
						size="s"
						style={'position:absolute;bottom:-5px;left:0;right:0;margin:auto;'}
					/>
					<Icon
						class="text-primary"
						icon="fa fa-map-marker"
						size="l"
						style={'position:relative;'}
					/>
					<Icon
						icon="fas fa-microchip"
						class="text-white"
						size="s"
						style={'position:absolute;top:8px;left:12px;filter:drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));'}
					/>
				</MapMarker>
			{/key}
		</Map>
	</div>
</div>

<style>
	.location-preview {
		display: flex;
		align-items: center;
		gap: var(--spacing-s, 8px);
		width: 100%;
	}
	.location-preview-map {
		position: relative;
		flex: 1;
		min-width: 0;
		height: 160px;
		overflow: hidden;
		pointer-events: none;
	}
</style>
